var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a-switch',{staticClass:"mr-2",attrs:{"size":"large","checked":_vm.showWeekend},on:{"change":_vm.onWeekendToggleChange}}),_c('span',{staticClass:"text-base"},[_vm._v(_vm._s(_vm.$t("showWeekend")))])],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }